import { defineComponent as e } from "vue";
const t = e({
  name: "RHobiStyles",
  render() {
    return null;
  }
});
export {
  t as _
};
